var map = {
	"./Dezembro2025/Arquitetura-Software-Moderna-Desenvolvedores.md": 2394,
	"./Dezembro2025/Modelos-Multidimensionais-Vetores.md": 8376,
	"./Dezembro2025/Monolito-modular.md": 2041,
	"./Dezembro2025/checklist-release-apis.md": 4837,
	"./Dezembro2025/guia-publicacao-artigos.md": 6141,
	"./Fevereiro2026/Model_Context_Protocol-MCP.md": 7940,
	"./Janeiro2026/Monolito-modular_part2.md": 6526,
	"./Janeiro2026/swapi-the-star-wars-api.md": 9480,
	"./Novembro2025/migracao-legado.md": 9951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9050;